module.exports = __webpack_public_path__ + "img/the_expeirince_centric.856d8770.jpg";